import { UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { TranslateProp } from '../../../common-types';
import { IAppStore } from '../../../HomeWorkouts';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils';
import { nextWorkoutSelector } from '../../selectors';
import Heading from './Heading';
import HeartRate from './HeartRate';
import WorkoutSettingsButton from './WorkoutSettingsButton';
import Zone from './Zone';

interface IParentProps {
  t: TranslateProp;
  userProfile: UserProfile;
}

interface IMappedProps {
  hydratedNextWorkout: UserWorkoutSession | undefined;
}

const DashboardHeaderStudioWorkoutStarting: FunctionComponent<IMappedProps & IParentProps> = (
  {
    hydratedNextWorkout,
    userProfile,
    t,
  },
) => {
  if (!hydratedNextWorkout) {
    return <></>;
  }
  return (
    <View style={styles.container}>
      <View style={styles.headingContainer}>
        <Heading workout={hydratedNextWorkout} t={t} />
        <Zone workout={hydratedNextWorkout} t={t} />
      </View>
      <View style={styles.buttonsContainer}>
        <HeartRate userProfile={userProfile} t={t} />
        <WorkoutSettingsButton workout={hydratedNextWorkout} t={t} userProfile={userProfile} />
      </View>
    </View>
  );
};

const mapStateToProps = (state: IAppStore): IMappedProps => ({
  hydratedNextWorkout: nextWorkoutSelector(state),
});

export default translate(['dashboard'], { wait: true })(connect(mapStateToProps)(DashboardHeaderStudioWorkoutStarting));

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.WHITE,
    padding: defaultScale(15),
    margin: defaultScale(10),
    borderRadius: defaultScale(5),
  },
  headingContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonsContainer: {
    flexDirection: 'row',
  },
});
